

function LikesOnClick(likeBtn){

    const fpPromise = FingerprintJS.load()
    fpPromise.then(fp => fp.get()).then((result)=>{ 
        _sendLikesClickEvent(likeBtn,result.visitorId)
    })
}

function _sendLikesClickEvent(likeBtn,fingerprintId){
    // console.log(">>>>>>>>",fingerprintId)

    var btnCustomerId = likeBtn.dataset.customerId;
    var btnShopId = likeBtn.dataset.shopId;
    var btnProductId = likeBtn.dataset.productId;
    var btnCollectionId = likeBtn.dataset.collectionId;
    var btnProductHandle = likeBtn.dataset.productHandle;

        if (likeBtn.classList.contains('loading')) return;

        // 如果当前已经是“已点赞”状态，什么都不做，不再发请求
        if (likeBtn.classList.contains('liked')) {
            console.log('Already liked, skip request');
            return;
        }

        // 当前是“未点赞”，才会走到这里
        // 先立刻改成“已点赞”UI，给用户即时反馈
        likeBtn.classList.add('liked');
        likeBtn.innerHTML = '❤️ Liked';

        likeBtn.classList.add('loading');
        likeBtn.setAttribute('aria-disabled', 'true');

        try {
            var ua = navigator.userAgent || '';
            var appType = /Android/i.test(ua) ? "android" : /iPhone|iPad/i.test(ua) ? "ios" : 'desktop';
            var language = navigator.language || ''
            if (Array.isArray(navigator.languages) && navigator.languages.length) {
                language = navigator.languages[0]; // 首选语言
            }

            // 并行：拿设备平台 + 语言 + 指纹
            const fpPromise = FingerprintJS.load()

            const fingerprint = fingerprintId;

            const data = {
                referer: location.href,
                shop_id: btnShopId,
                collection_id: btnCollectionId,
                product_id: btnProductId,
                customer_id: btnCustomerId,
                app_type: appType,        // android / ios / desktop
                language: language,       // 浏览器首选语言
                fingerprint: fingerprint  // 浏览器指纹
            };

            // 发送到你的后端点赞接口
            fetch('https://sysback.hiywy.com/shopify/productLike', {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "from-shopify": "12@#",
                    "Content-Type": "application/json"
                },
            }).then((response) => {
                return response.text();
            })
            .then((state) => {
                const result = JSON.parse(state);
                console.log('productLike result:', result);
            })
            .catch(() => {
                console.warn('productLike failed, status:', res.status);
                // 请求失败时，把 UI 改回“未点赞”
                likeBtn.classList.remove('liked');
                likeBtn.innerHTML = 'Like';
            })
            .finally(() => {
                
            });
      } catch (error) {
        console.error('error:', error);
        // 失败时把 UI 改回去
        likeBtn.classList.remove('liked');
        likeBtn.innerHTML = 'Like';
      } finally {
        likeBtn.classList.remove('loading');
        likeBtn.removeAttribute('aria-disabled');
      }
}
function LikesBtnInit(likeBtn){
    const fpPromise = FingerprintJS.load()

    fpPromise.then(fp => fp.get()).then((result)=>{ 
        _loadLikedProductIds(likeBtn,result.visitorId)
    }
    );
}
function _loadLikedProductIds(likeBtn,fingerprintId) {
    
    // console.log(">>>>>>>>",fingerprintId)

    try {
        
        // 从详情页按钮拿当前商品 ID
        const btnCustomerId = likeBtn.dataset.customerId;
        const btnShopId = likeBtn.dataset.shopId;
        const btnProductId = likeBtn.dataset.productId;
        const btnCollectionId = likeBtn.dataset.collectionId;

        const data = {
          product_id: btnProductId,   // 详情页：只查当前商品
          shop_id: btnShopId,
          collection_id: btnCollectionId,
          customer_id: btnCustomerId,
          fingerprint: fingerprintId
        };

        fetch('https://sysback.hiywy.com/shopify/getProductLikeIds', {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            "from-shopify": "12@#",
            "Content-Type": "application/json"
          },
        }).then((response) => {
                return response.text();
            })
            .then((state) => {
                const json = JSON.parse(state);
                let liked = false;
                if (json && json.data && typeof json.data.liked !== 'undefined') {
                    liked = !!json.data.liked;
                }
                if (likeBtn) {
                    if (liked) {
                        likeBtn.classList.add('liked');
                        likeBtn.innerHTML = '❤️ Liked';
                    } else {
                        likeBtn.classList.remove('liked');
                        likeBtn.innerHTML = 'Like';
                    }
                }
            })
            .catch(() => {
                console.warn('productLike failed, status:', res.status);
            })
            .finally(() => {
                
            });


    } catch (err) {
        console.warn('>>>>>>>>>loadLikedProductIds error:', err);
    }
}